import { useConfig } from '@/shared/utils/config/config-context';
import { FeatureFlag } from '../feature-flags';
import { useFeatureFlag } from './useFeatureFlag';

export function useIsMastraStudioEnabled(): boolean {
    const { config } = useConfig();
    const isStudioEnabled = useFeatureFlag(FeatureFlag.F_ENABLE_MASTRA_STUDIO);
    const isAiHubEnabled = useFeatureFlag(FeatureFlag.F_AI_HUB);
    return config?.ENVIRONMENT_NAME === 'local' || (isStudioEnabled && isAiHubEnabled);
}
